const memberTypes = {
    MEMBER: 1,
    CONTACT: 2
};

export { memberTypes };
